<template>
    <section class="col s12">
        <div class="row">
            <div class="col s6">
                <p>
                    Sua ação possui parcerias externas?
                </p>

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize" name="acao_possui_parcerias_externas"
                               class="with-gap"
                               type="radio"
                               id="rdSimAcaoPossuiParceriasExternas"
                               :disabled="allDisabled"
                               :value="true"
                               v-model="acaoPossuiParceriasExternas"/>
                        <span>Sim</span>
                    </label>
                </div>
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize" name="acao_possui_parcerias_externas"
                               :disabled="allDisabled"
                               class="with-gap"
                               type="radio"
                               id="rdNaoAcaoPossuiParceriasExternas"
                               :value="false"
                               v-model="acaoPossuiParceriasExternas"/>
                        <span>Não</span>
                    </label>
                </div>
            </div>
            <div class="input-field col s6" v-if="acaoPossuiParceriasExternas">
                <input type="number"
                       min="1"
                       :disabled="allDisabled"
                       name="quantidade_parcerias"
					   id="quantidade_parcerias" 
                       v-model:value="quantidade_parcerias">
                <label for="quantidade_parcerias">Quantidade de Parcerias</label>
            </div>
        </div>

        <div class="row" v-if="acaoPossuiParceriasExternas">

            <div v-for="(e, i) in quantidade" :key="i" class="animate__animated animate__fadeInDown">
                <div class="col s12">
                    <div class="card-header">{{ e + 1 }} - Declaração de parceria</div>
                    <div class="card-panel">
                        <div class="row">
                            <h5 class="col s12">
                                Faça o upload do arquivo PDF com a declaração de parceria
                            </h5>
                            <h6 class="col s12">
                                <b>O total de arquivo deve ter até 5 Mb.</b>
                            </h6>
                        </div>
                        <div class="row">
                            <div class="col s12">
                                <i class="material-icons left">attach_file</i>

                                <a class="btn-floating btn-small waves-effect waves-light red"
                                   :disabled="allDisabled"
                                   @click="acionaEventoDeFileUpload(i)"
                                   title="Upload do arquivo com a parceria">
                                    <i class="material-icons">file_upload</i>

                                    <input tipo="materialize"
                                           class="btn"
                                           :disabled="allDisabled"
                                           required
                                           pai="inscricao"
                                           type="file" :id="'parcerias_file_upload'+i" :name="'parcerias_file_upload'+i"
                                           accept="application/pdf"
										   :ref="'parcerias_file_upload'+i"
                                           @change="uploadArquivo(i)">
                                </a>

                                &nbsp;

                                <span v-if="!anexos || anexos[i] === undefined"
                                      class="">Nenhum arquivo anexado...</span>

                                <div v-else style="display: inline;">
                                    &nbsp;

                                    <a class="btn-flat blue-text"
                                       :download="anexos[i].nome_anexo"
                                       :href="linkParaDownload(anexos[i])">
                                        <i class="material-icons left">file_download</i>
                                        {{ anexos[i].nome_anexo }}
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="row" v-if="analiseTecnica">
            <div class="col s12">
                <div class="card-panel" style="border: 2px solid #8c9eff">
                    <div class="row">
                        <h5 class="col s12">
                            Resultado da Análise Técnica
                        </h5>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <table class="responsive-table striped centered">
                                <thead>
                                <tr>
                                    <th>Opção selecionada</th>
                                    <th>Pontuação</th>
                                    <th>Avaliação</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <span>{{ analiseTecnica.item_acao_possui_parcerias_externas_opcao }}</span>
                                    </td>
                                    <td>
                                        <span>{{
                                                analiseTecnica.item_acao_possui_parcerias_externas_pontuacao
                                              }} pontos</span>
                                    </td>
                                    <td>
                                        <span class="new badge blue" data-badge-caption="">{{
                                                startCase(analiseTecnica.item_acao_possui_parcerias_externas_validacao)
                                                                                           }}</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import file_uploads from "../../../utils/file_uploads";

export default {
    name: "parcerias",
    props: {
        pAcaoPossuiParceriasExternas: {
            type: Boolean,
            default: false,
        },
        pQuantidadeParcerias: {
            type: Number,
            default: 1
        },
        pAnexos: {
            type: Array,
            default: () => {
                return []
            },
        },
        pAnaliseTecnica: {
            type: Object,
            default: () => null,
        },
        allDisabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            acaoPossuiParceriasExternas: this.pAcaoPossuiParceriasExternas,
            anexos: this.pAnexos,
            analiseTecnica: this.pAnaliseTecnica,
            quantidade_parcerias: this.pQuantidadeParcerias,
        }
    },
    watch: {
        pAcaoPossuiParceriasExternas(newValue) {
            this.acaoPossuiParceriasExternas = newValue
        },
        acaoPossuiParceriasExternas(newValue) {
            /*if(!newValue)
                this.excluiTodosOsAnexosComDeclaracoesDeParcerias()*/

            this.$emit('update:pAcaoPossuiParceriasExternas', newValue)
        },
        pAnexos: {
            deep: true,
            handler(newValue) {
                this.anexos = newValue
            }
        },
        anexos: {
            deep: true,
            handler(newValue) {
                this.$emit('update:pAnexos', newValue)
            }
        },
        quantidade_parcerias(newValue) {
                this.$emit('update:pQuantidadeParcerias', newValue)
        }

    },
    computed: {
        quantidade() {
            let l = this.quantidade_parcerias;
            this.excluiTodosOsAnexosComDeclaracoesDeParcerias(l)
            return Array.apply(null, {length: l}).map(Number.call, Number)
        }
    },
    methods: {
        startCase(texto) {
            return _.startCase(texto)
        },
        acionaEventoDeFileUpload(i) {
            const field = 'parcerias_file_upload' + i;
            const inputFileUpload = this.$refs[field][0];

            inputFileUpload.click()
        },
        uploadArquivo(i) {
            const field = 'parcerias_file_upload' + i;

            const inputFileUpload = this.$refs[field][0];

            const arquivos = inputFileUpload.files

            if (arquivos !== undefined && arquivos !== null) {
                //Pega o arquivo anexado no input
                const arquivo = arquivos[0]

                const anexo = file_uploads.retornaAnexo(arquivo, arquivo.name, 'INSCRICAO_DECLARACOES_DE_PARCERIAS', ['pdf'])

                if (anexo) {
                    //Sobreescreve a posição equivalente do anexo.
                    // this.anexos[i] = anexo // não reativo
                    this.anexos.splice(i, 1, anexo);

                    // $vm.$set($vm.anexos,i,anexo) // reativo

                    // this.excluiTodosOsAnexosComDeclaracoesDeParcerias(i-1)

                    M.toast({html: 'Arquivo anexado!'})
                }
            }
        },

        excluiTodosOsAnexosComDeclaracoesDeParcerias(i) {
            //Atualizado para remover somente o elemeento equivalente
            if (this.anexos[i] !== undefined)
                this.anexos.splice(i)
        },

        linkParaDownload(anexo) {
            return file_uploads.linkParaDownloadDeAnexosEmGeral(anexo)
        }
    },
}
</script>

<style scoped>

</style>
